// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3s3Aw","search":"Settings_search__1K3Fm","filter":"Settings_filter__29eYQ"};